/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskEvaluationConfigCompletionMinLevelsOverrideAnyOf } from './taskEvaluationConfigCompletionMinLevelsOverrideAnyOf';

export type TaskEvaluationConfigCompletionMinLevelsOverride =
  TaskEvaluationConfigCompletionMinLevelsOverrideAnyOf | null;
